import { PromoContent, PromoSlider, PromoTitle } from './style';
import InfoIcon from '../../assets/icons/info.svg?react';
import CheckIcon from '../../assets/icons/check.svg?react';
import { useThemeContext } from '../../../features/Theme/providers/ThemeContextProvider';
import { Space } from '../Space/style';

export function Promo() {
	const theme = useThemeContext();

	return (
		<PromoSlider>
			<InfoIcon fill={theme.colors.neutral[500]} width={22} height={22} />
			<PromoTitle>
				Si el especialista te hace una prescripción:
			</PromoTitle>
			<PromoContent>
				<ul>
					<li><CheckIcon fill={theme.colors.neutral[400]}/><Space size={8} direction="horizontal" /><span>Te enviaremos el volante por email.</span></li>
					<li><CheckIcon fill={theme.colors.neutral[400]}/><Space size={8} direction="horizontal" /><span>Para abrir la prescripción introduce los 12 dígitos de tu tarjeta.</span></li>
					<li><CheckIcon fill={theme.colors.neutral[400]}/><Space size={8} direction="horizontal" /><span>Si la prescripción requiere autorización de MAPFRE, solicítala por la app y ya podrás pedir cita.</span></li>
				</ul>
			</PromoContent>
		</PromoSlider>
	);
}
